import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const FavoriteAssetsWrapper = styled.div``;

export const HeaderLoader = styled(ContentLoader)`
  display: none;

  height: 4.1rem;
  width: 100%;

  ${({ theme }) => theme.media.laptop`
    display: initial;
  `};
`;

export const Amount = styled.rect`
  height: 2rem;
  width: 7rem;

  y: 1.5rem;
  x: 60%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
  ${({ theme }) => theme.media.laptop`
      y: 2.5rem;
      x: 27%;
  `};
`;

export const Percentage = styled.rect`
  height: 1.6rem;
  width: 3rem;

  y: 4rem;
  x: 70%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
  ${({ theme }) => theme.media.laptop`
      y: 2.5rem;
      x: 49%;
  `};
`;

export const BodyLoader = styled(ContentLoader)`
  height: 6.8rem;
  width: 100%;
`;

export const BodyLine = styled.rect`
  height: 0.1rem;
  width: 100%;
`;

export const AssetIcon = styled.circle`
  r: 1.7rem;
  cx: 2.7rem;
  cy: 3.4rem;

  ${({ theme }) => theme.media.mobileL`
      cx: 3.8rem;
  `};

  ${({ theme }) => theme.media.laptop`
      cx: 3.5rem;
      r: 2rem;
  `};
`;

export const FavoriteIcon = styled.circle`
  r: 2.2rem;
  cx: 88%;
  cy: 3.4rem;

  ${({ theme }) => theme.media.laptop`
      r: 2rem;
      cx: 89%;
      cy: 3.4rem;
  `};
`;

export const AssetName = styled.rect`
  height: 1.8rem;
  width: 7rem;

  x: 5.4rem;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 6.8rem;
  `};
`;

export const AssetCode = styled.rect`
  height: 1.6rem;
  width: 4rem;

  x: 5.4rem;
  y: 3.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 6.8rem;
  `};
`;

export const Button = styled.rect`
  display: none;
  height: 3.5rem;
  width: 15rem;

  y: 1.5rem;
  x: 72%;

  rx: ${({ theme }) => theme.borderRadius.high};
  ry: ${({ theme }) => theme.borderRadius.high};
  ${({ theme }) => theme.media.laptop`
      display: block;
  `};
`;
